import { connect } from 'react-redux';
import { actions } from 'app-webtech-core';
import { PlayerContainer } from './container';

const mapStateToProps = undefined;

const mapDispatchToProps = (dispatch) => ({
  videoBitRateChange: (bitrate) => dispatch(actions.player.videoBitRateChange(bitrate)),
  heartBeat: (seconds) => dispatch(actions.playbackSession.heartBeat({ seconds })),
  sessionReset: () => dispatch(actions.playbackSession.sessionReset()),
});

export const Player = connect(mapStateToProps, mapDispatchToProps)(PlayerContainer);
